export default function RadioInputButton({
  className,
  emoji,
  image,
  label,
  name,
  onChange,
  text,
  value,
}: {
  className?: string
  emoji?: string
  image?: string
  label?: string
  name: string
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  text?: string
  value: string
}) {
  return (
    <label
      className={`${className} custom-button-input flex items-center gap-4`}
    >
      <input
        className="hidden"
        name={name}
        onChange={onChange}
        type="radio"
        value={value}
      />

      {image && <img className={"mr-1 w-20"} src={image} />}

      {emoji && (
        <span className="text-shadow mr-1 text-3xl shadow-[#0000002E]">
          {emoji}
        </span>
      )}

      {label}

      {text && (
        <>
          <br />
          <span className="text-xs">{text}</span>
        </>
      )}
    </label>
  )
}
